import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

import {
	PRISM_DIALOG_DATA,
	PrismBetaIndicatorComponent,
	PrismButtonComponent,
	PrismCheckboxComponent,
	PrismDialogComponent,
	PrismDialogRef,
	PrismIconComponent
} from '@shure/prism-angular-components';
import { provideInlineScope } from '@shure/shared/angular/utils/i18n';

export interface PrismInfoDialogData {
	title?: string;
	body?: string[];
	okLabel: string;
	showWarningIcon?: boolean;
	showBetaIcon?: boolean;
	doNotShowDialogId?: string;
}

@Component({
	selector: 'sh-info-dialog',
	templateUrl: './prism-info-dialog.component.html',
	styleUrls: ['./prism-info-dialog.component.scss'],
	imports: [
		CommonModule,
		TranslocoModule,
		PrismBetaIndicatorComponent,
		PrismButtonComponent,
		PrismCheckboxComponent,
		PrismDialogComponent,
		PrismIconComponent
	],
	providers: [provideInlineScope('scInfoDialog', (lang) => import(`../../i18n/${lang}`))]
})
export class PrismInfoDialogComponent {
	public doNotShowDialog = false;

	constructor(
		private readonly dialogRef: PrismDialogRef<PrismInfoDialogComponent, boolean>,
		@Inject(PRISM_DIALOG_DATA) public readonly data: PrismInfoDialogData
	) {}

	public toggleDoNotShowDialog(doNotShowDialog: boolean): void {
		this.doNotShowDialog = doNotShowDialog;
	}

	public handleBodyClick(event: MouseEvent): void {
		const target = <HTMLElement>event.target;
		if (target.tagName === 'A') {
			this.close();
		}
	}

	public close(): void {
		this.dialogRef.close(this.doNotShowDialog);
	}
}
